const moment = require('@transfeeradev/moment');

class TEVHourService {
  constructor() {}

  isValid() {
    const current = moment();
    const start = moment('08:00:00', 'HH:mm:ss');
    const end = moment('19:00:00', 'HH:mm:ss');

    // '[]' [] indicates inclusion of a value. i.e. IsSameOrBetween
    return current.isBetween(start, end, null, '[]');
  }
}

module.exports = TEVHourService;
